<template>
  <HealthForm width="w-full lg:max-w-[30rem]" gap="gap-5" @submit="emit('submit')">
    <header class="flex flex-col items-center justify-center col-span-12 text-center gap-6 mb-4">
      <div class="flex items-center gap-3">
        <Icon icon="bi:lungs" class="text-4xl text-primary-500 dark:text-white" />

        <HealthLogo width="250" :color="color" height="40" />
      </div>

      <section class="flex flex-col gap-1">
        <h1 class="text-2xl font-bold text-gray-900 dark:text-white">
          {{ t("welcome_back_title") }}
        </h1>
        <p class="text-sm text-gray-500 dark:text-gray-400 font-medium">
          {{ t(subtitle) }}
        </p>
      </section>
    </header>

    <slot />
  </HealthForm>
</template>

<script setup lang="ts">
  import HealthForm from "@/shared/components/form/form/HealthForm.vue";
  import { useI18n } from "vue-i18n";
  import { useColorMode } from "@vueuse/core";
  import { computed } from "vue";
  import { Icon } from "@iconify/vue";
  import HealthLogo from "@/shared/components/utils/HealthLogo.vue";

  const emit = defineEmits(["submit"]);
  const { t } = useI18n();
  const { state } = useColorMode({
    initialValue: "light",
  });

  const color = computed(() => {
    return state.value === "dark" ? "#ffffffff" : "#000000";
  });

  defineProps({
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
  });
</script>
